import React from 'react';
import { string } from 'prop-types';
import { FULFILLMENT_METHODS } from '../../constants';
import { TileHead } from './TileHead';

const NotAvailable = (props) => {
  const { type } = props;
  const getTitle = (fulfillType) => {
    switch (fulfillType) {
    case FULFILLMENT_METHODS.APPLIANCE:
    case FULFILLMENT_METHODS.STH:
    case FULFILLMENT_METHODS.BODFS:
      return 'Delivery';
    case FULFILLMENT_METHODS.BOPIS:
      return 'Pickup';
    case FULFILLMENT_METHODS.STORE:
      return 'Ship to Store';
    default:
      return null;
    }
  };

  return (
    <div className="fulfillment-tile">
      <TileHead title={getTitle(type)} />
      <div className="fulfillment-msg">Unavailable</div>
    </div>
  );
};
NotAvailable.propTypes = {
  type: string
};
NotAvailable.defaultProps = {
  type: null
};

export { NotAvailable };
